export enum CookieKey {
  UserTenant = 'selected-tenant',
  PortalLanguage = 'selected-portal-language',
  TecDocLanguage = 'selected-tecdoc-language',
}